import { ClassifierVersion } from '../../types'

function versionDotClass(status: ClassifierVersion['status']): string {
    if (status === 'live') return 'bg-safe'
    if (status === 'draft') return 'bg-gray-400'
    return 'bg-gray-300'
}

/**
 * The version history, newest first. Selecting a row loads that version into the
 * prompt card — which is why selection lives on the page rather than in here.
 */
export default function VersionsRail({
    versions,
    selectedVersion,
    onSelect
}: {
    versions: ClassifierVersion[]
    selectedVersion: ClassifierVersion
    onSelect: (version: ClassifierVersion) => void
}) {
    return (
        <div className="bg-white border border-gray-200 rounded-lg">
            <div className="px-4 py-3 border-b border-gray-100 font-semibold text-sm text-gray-700 flex items-center justify-between">
                <span>Versions</span>
                <span className="text-gray-400 font-normal">{versions.length}</span>
            </div>
            <div className="p-1.5 space-y-0.5">
                {versions.map((v) => {
                    const isSelected = v.version === selectedVersion.version
                    return (
                        <button
                            key={v.version}
                            type="button"
                            onClick={() => onSelect(v)}
                            className={`w-full text-left flex gap-2.5 px-2.5 py-2 rounded-lg transition-colors ${
                                isSelected
                                    ? 'bg-arwen-50 border border-arwen-200'
                                    : 'hover:bg-gray-50'
                            }`}
                            aria-pressed={isSelected}
                        >
                            {/* Status dot */}
                            <span
                                className={`mt-1.5 w-2 h-2 rounded-full flex-shrink-0 ${versionDotClass(v.status)}`}
                                aria-hidden="true"
                            />
                            <div>
                                <div className="inline-flex items-center gap-1 text-sm font-semibold text-gray-900">
                                    <span>v{v.version}</span>
                                    {v.status === 'live' && (
                                        <span className="text-[9.5px] font-bold tracking-wide px-1.5 py-0.5 rounded bg-green-100 text-safe uppercase">
                                            LIVE
                                        </span>
                                    )}
                                    {v.status === 'draft' && (
                                        <span className="text-[9.5px] font-bold tracking-wide px-1.5 py-0.5 rounded bg-gray-100 text-gray-500 uppercase">
                                            DRAFT
                                        </span>
                                    )}
                                </div>
                                <div className="text-[11.5px] text-gray-500 mt-0.5">
                                    {v.author} · {v.date}
                                </div>
                            </div>
                        </button>
                    )
                })}
            </div>
        </div>
    )
}
